import * as React from 'react';
import { useSelector } from 'react-redux';

import { TechProblems } from '../../components/TechProblems';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectLayoutType } from '../../selectors/layoutType';
import { TechProblemsModalContainer } from './TechProblemsModal';
import { TITLE } from './constants';

export const TechProblemsContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const layoutType = useSelector(selectLayoutType);
  const techProblemsBannerEnabled = config.get('feedbackForm.techProblemsBanner.enabled');

  if (!techProblemsBannerEnabled) {
    return null;
  }

  if (layoutType === 'modal') {
    return <TechProblemsModalContainer />;
  }

  return <TechProblems title={TITLE} />;
};
